import { StyleSheet } from 'react-native';

export const ICON_SIZE = 10;

const defaultStyles = {
    content: {
        ...StyleSheet.absoluteFill,
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        height: '100%',
        width: '100%',
        zIndex: 999
    },
    withArrow: { marginVertical: 10 },
    modal: {
        position: 'absolute',
        maxHeight: 300
    },
    icon: { width: ICON_SIZE, height: ICON_SIZE, position: 'absolute' }
};

export default defaultStyles;
